import { PropertyFilterProps } from "@amzn/awsui-components-react/polaris/property-filter/interfaces";

/**
 * Converts property filter tokens into a grouped object structure.
 * If the property filters doesn't contain any key its ignored.
 *
 * @param {ReadonlyArray<PropertyFilterProps.Token>} tokens - Array of property filter tokens to convert
 * @return {{ [key: string]: string[] }} - Object with property keys mapped to arrays of their values
 */
export const convertTokensToPropertyFilter = (
    tokens: ReadonlyArray<PropertyFilterProps.Token>,
): { [key: string]: string[] } => {
    const result: { [key: string]: string[] } = {};

    tokens.map((i) => {
        const value = i.value.trim();

        if (!i.propertyKey) {
            return;
        }

        if (Object.keys(result).includes(i.propertyKey!)) {
            result[i.propertyKey!].push(value);
        } else {
            result[i.propertyKey!] = [value];
        }
    });

    return result;
};

/**
 * Converts property filter tokens into separate filter objects for AND operations.
 * Each token becomes a separate object with the property key and single value.
 *
 * @param {ReadonlyArray<PropertyFilterProps.Token>} tokens - Array of property filter tokens to convert
 * @return {Array<{ [key: string]: string }>} - Array of filter objects for AND operations
 */
export const convertTokensToAndFilters = (
    tokens: ReadonlyArray<PropertyFilterProps.Token>,
): Array<{ [key: string]: string }> => {
    const result: Array<{ [key: string]: string }> = [];

    tokens.forEach((token) => {
        const value = token.value.trim();

        if (token.propertyKey) {
            result.push({ [token.propertyKey]: value });
        }
    });

    return result;
};
